/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Table,
  Label,
} from 'shpmtcd'
import dayjs from 'dayjs'

const createColumns = (merchant, getOrderStatus) => {
  const columns = [
    {
      title: 'Order Code',
      key: 'code',
      render: (data) => {
        const { code: OrderID } = data
        const merchantCanonicalName = merchant
        return (
          <a
            href={
              `${window.location.origin}/checkout/merchants/${merchantCanonicalName}/thank_you/${OrderID}/print`
            }
            target='_blank'
            rel='noreferrer'
          >
            {OrderID}
          </a>
        )
      },
    },
    {
      title: 'Date of Purchase',
      key: 'created_at',
      render: (data) => `${dayjs(data.created_at).format('D MMMM, YYYY')}`,
    },
    {
      title: 'Status',
      key: 'status',
      render: (data) => <Label>{data.status}</Label>,
    },
    {
      title: 'Amount',
      key: 'amount',
      render: (data) => `${data.currency} ${data.total}`,
    },
    {
      title: 'Track Order',
      key: 'track_order',
      render: (data) => {
        const { code: OrderID } = data
        return (
          <Button
            type='Text'
            onClick={() => {
              getOrderStatus(OrderID)
            }}
          >
            Track
          </Button>

        )
      },
    },
  ]
  return columns
}

// Empty Content
const emptyContent = (
  <div className='empty-orders-content'>
    <h3>You don&apos;t have any orders yet</h3>
    <Button
      type='Ghost'
    >
      <a href={window.location.origin} className='go-to-shop-link'>Go to shop</a>
    </Button>
  </div>
)
const empty = {
  emptyText: emptyContent,
}

const OrdersTable = ({
  orders, pagination, getOrders, merchant, getOrderStatus,
}) => (
  <Table
    columns={createColumns(merchant, getOrderStatus)}
    dataSource={orders}
    pagination={{
      defaultCurrent: 1,
      pageSize: 8,
      total: pagination.totalItems,
      hideOnSinglePage: true,
      showSizeChanger: false,
    }}
    locale={empty}
    className='orders-table'
    scroll={{ x: 650 }}
    onChange={(pageNumber) => {
      getOrders((pageNumber.current), 8)
    }}
  />
)

OrdersTable.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.object).isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.string,
    firstItemIndex: PropTypes.number,
    lastItemIndex: PropTypes.number,
    perPage: PropTypes.string,
    totalItems: PropTypes.number,
    totalPages: PropTypes.number,
  }).isRequired,
  getOrders: PropTypes.func.isRequired,
  getOrderStatus: PropTypes.func.isRequired,
  merchant: PropTypes.string.isRequired,
}

export default OrdersTable
